declare global {
	interface Window {
		chrome: any;
	}
}

export const isChromiumBased = (): boolean => {
	const userAgent = navigator.userAgent.toLowerCase();
	return userAgent.includes('chrome') || !!window?.chrome;
};

export const isMobileBrowser = (): boolean => {
	const userAgent = navigator.userAgent.toLowerCase();
	return (
		userAgent.includes('mobile') ||
		userAgent.includes('android') ||
		userAgent.includes('iphone') ||
		userAgent.includes('ipad')
	);
};

export const isWebView = (): boolean => {
	/**
	 * For Cosmos App v1 only
	 * Pre-requirement: append word "WebView" in the `applicationNameForUserAgent` of the react-native WebView
	 */
	const userAgent = navigator.userAgent.toLowerCase();
	return userAgent.includes('webview');
};
